import React, { memo } from 'react';
import cn from 'classnames';
import styles from './index.module.less';
import { HeaderLogo, IHeaderLogoProps } from '@pro/common/HeaderLogo';
import HeaderSearch from '@app/common/PageHeader/HeaderSearch';
import HeaderSupport from '@app/common/PageHeader/HeaderSupport';
import HeaderAccount from '@app/common/PageHeader/HeaderAccount';
import HeaderCart from '@app/common/PageHeader/HeaderCart';
import HeaderCountry from '@app/common/PageHeader/HeaderCountry';
import HeaderGuide from '@app/common/PageHeader/HeaderGuide';
import HeaderCommunity from '@app/common/PageHeader/HeaderCommunity';

type HeaderBarProps = {
    disableMiniCart?: boolean;
    onlyShowLogo?: boolean;
    logoType?: IHeaderLogoProps['logoType'];
};

const HeaderBar: React.FC<HeaderBarProps> = props => {
    const {
        disableMiniCart = false,
        onlyShowLogo = false,
        logoType,
    } = props;

    return (
        <div className={cn('header-bar', styles['header-bar'])}>
            <div id="js-header-bar-scope" className="wrapper-large flex flex-middle flex-wrap relative">
                <div className={cn('flex flex-middle', styles.left)}>
                    <HeaderLogo type={logoType}/>
                </div>

                {!onlyShowLogo && (
                    <>
                        <HeaderSearch className={cn(styles.center, 'text-center')}/>

                        <div className={cn(styles.right, 'text-right')} id={'js-header-bar-right'}>
                            <HeaderSupport/>
                            <HeaderGuide/>
                            <HeaderCommunity/>
                            <HeaderCountry/>
                            <HeaderAccount/>
                            <HeaderCart disableMiniCart={disableMiniCart}/>
                        </div>
                    </>
                )}
            </div>
        </div>
    )
};

export default memo(HeaderBar);